module.exports = __webpack_public_path__ + "search-small.9a941f8a4ef1a0f5d9ef80d0bc81d3d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/search-small.svg
// module id = 364
// module chunks = 0